import { IAsignarRol } from "../Interfaces/IUsuario";
import { CLAIM_CUSTOMER_ID } from "../utils/helpers/roleHelpers";
import AuthenticationService from "./Authentication/AuthenticationService";
import { fetchAdministracion, fetchIdentidad } from "./http-common";

const cambiarContrasenia = (data: {}) => {
  return fetchIdentidad.put(`v1/ActualizarContraseniaActual`, data);
};

const politicasContrasenia = () => {
  return fetchIdentidad.get(`v1/PoliticaContrasenia`);
};

const rolesByUser = (data: {}) => {
  return fetchIdentidad.post(`v1/RolByUser`, data);
};

const userById = (data: {}) => {
  return fetchAdministracion.post(`Usuario/ListarPorId`, data);
};

const allRol = () => {
  return fetchIdentidad.get(`v1/AllRole`);
};

const asignarRolByUser = (data: IAsignarRol) => {
  return fetchIdentidad.post(`v1/User/AssignRolesForPerson`, data);
};

const quitarRolUser = (data: { identityId: string; roleId: string }) => {
  return fetchIdentidad.post(`v1/User/RemoveRole`, data);
};

const listarCuentasPorUsuario = (usuarioId: string) => {
  return fetchAdministracion.get(
    `UsuarioCuenta/ListarCuentaPorUsuarioId/${usuarioId}`
  );
};

const eliminarCuentaByUser = (usuarioCuentaId: string) => {
  return fetchAdministracion.delete(`UsuarioCuenta/${usuarioCuentaId}`);
};

const getAllCuentas = (customerId: string) => {
  return fetchAdministracion.get(`Cuenta/${customerId}`);
};

const asignarCuenta = (data = {}) => {
  return fetchAdministracion.post(`UsuarioCuenta/CrearByUser`, data);
};

const usuarioServicio = {
  cambiarContrasenia,
  politicasContrasenia,
  rolesByUser,
  userById,
  allRol,
  asignarRolByUser,
  quitarRolUser,
  listarCuentasPorUsuario,
  eliminarCuentaByUser,
  getAllCuentas,
  asignarCuenta,
};

export default usuarioServicio;
